import React from 'react'

import logo from "../../assets/images/logo.png"
import sideBarImg from "../../assets/images/sidebar-img.png";
import "./website-sidebar.css";
import { useNavigate } from 'react-router-dom';

function WebsiteSidebar() {
  const navigate = useNavigate();
  return (
    <nav className="website-sidebar">
      <div className='logo-img' onClick={() => navigate("/")}>
        <img src={logo} alt="newbanger logo" />
      </div>
      <div className='sidebar-content'>
        <div className='selfie-img'><img src={sideBarImg} alt="Selfie for side bar login" /></div>
        <p>Take your music career to the next level, Music promotion just got easier, sign up to promote your song on blogs, Social media, Playlists, radio and more at a lesser cost in a more transparent way</p>
      </div>
    </nav>
  )
}

export default WebsiteSidebar